import Axios from 'axios';
import moment from 'moment'
import { STATUS } from './constants'


export const Get = (url, header) => {
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    let authHeader = { ...headers, ...header };
    return Axios.get(url, { headers: authHeader }).then(data => data).catch(error => { throw error; });
};

export const Post = (url, data, header) => {
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
    let authHeader = { ...headers, ...header };
    return Axios.post(url, data, { headers: authHeader }).then(data => data).catch(error => { throw error; });
};

export const Delete = (url, header) => {
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
    let authHeader = { ...headers, ...header };
    return Axios.delete(url, { headers: authHeader }).then(data => data).catch(error => { throw error; });
};

export const CheckIfHasEmpty = (obj, keys = []) => {
    let ret = true;
    if (obj === {}) {
        return false;
    } else {
        keys.forEach(e => {
            if (obj[e] === {} || obj[e] === '' || obj[e] === undefined || obj[e].length === 0) {
                ret = false;
            }
        });
    }
    return ret;
};

export const isEmpty = (obj) => {
    const hasOwnProperty = Object.prototype.hasOwnProperty;
    if (obj == null) return true;
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    if (typeof obj !== "object") return true;
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}



export const orderString = (a, b) => {
    if (!a) a = ''
    if (!b) b = ''
    return a.localeCompare(b)
}

export const orderDate = (a, b) => {
    const date_a = moment(a, 'DD/MM/YYYY HH:mm').toDate().getTime() || 0
    const date_b = moment(b, 'DD/MM/YYYY HH:mm').toDate().getTime() || 0

    return date_a - date_b
}

export const getKeyFromStatus = (text) => {
    for (let key in STATUS) {
        if (STATUS[key] === text) {
            return key
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/functions.js